var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Play button"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1",
    d: "M17.4623 13.0297C18.1936 12.5425 18.1936 11.4681 17.4623 10.9809L8.91236 5.2852C8.09436 4.74026 6.99909 5.32668 6.99909 6.30957V17.7011C6.99909 18.684 8.09436 19.2704 8.91236 18.7254L17.4623 13.0297Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/play-icon.6797c112cfb0c86ca055cbb995a0e53e.svg";
export { ForwardRef as ReactComponent };